import tailwindColors from "tailwindcss/colors"
import {useLayoutStore} from "@/store/layout"

export const $getCurrentModule = () => {
    const module = useLayoutStore().currentModule
    return module ? appModules[module] : null
}

export const $getModuleIcon = (module?: string): string | null => {
    if (!module) return $getCurrentModule()?.icon ?? null
    return appModules[module]?.icon ?? null
}

export const $getModuleColor = (module?: string): string | null => {
    if (!module) return $getCurrentModule()?.color ?? null
    return appModules[module]?.color ?? null
}

export const $getModuleTextColor = (module?: string): string | null => {
    if (!module) return $getCurrentModule()?.color?.text ?? null
    return appModules[module]?.color?.text ?? null
}

export const $getModuleBackgroundColor = (module?: string): string | null => {
    if (!module) return $getCurrentModule()?.color?.background ?? null
    return appModules[module]?.color?.background ?? null
}

export const appColors = {
    ...tailwindColors,
    primary: {
        "50": "#eff6ff",
        "100": "#dbeafe",
        "200": "#bfdbfe",
        "300": "#93c5fd",
        "400": "#60a5fa",
        "500": "#3b82f6",
        "600": "#2563eb",
        "700": "#1d4ed8",
        "800": "#1e40af",
        "900": "#1e3a8a",
        "950": "#172554"
    }
}

export const appModules: AppModules = {
    primary: {
        name: 'primary',
        color: appColors.primary
    },
    dashboard: {
        name: 'dashboard',
        icon: 'heroicons:home',
        color: 'primary'
    },
    users: {
        name: 'users',
        icon: 'heroicons:users',
        color: appColors.cyan,
        search: {
            listing: 'service-settings-users',
            detail: 'service-settings-users-id-userBaseData',
            nameProp: 'fullname'
        },
    },
    organisations: {
        name: 'organisations',
        icon: 'heroicons:user',
        color: appColors.yellow,
        search: {
            listing: 'service-settings-organisations',
            detail: 'service-settings-organisations-id-organisationBaseData',
            nameProp: 'name'
        },
    },
    processes: {
        name: 'processes',
        icon: 'heroicons:clipboard-document-list',
        color: appColors.lime,
        search: {
            listing: 'service-processes',
            detail: 'service-processes-id-processBaseData',
            nameProp: 'process_number'
        },
    },
    reporting: {
        name: 'reporting',
        icon: 'heroicons:chart-bar-square',
        color: appColors.violet
    },
    payments: {
        name: 'payments',
        icon: 'ph:coins-light',
        color: appColors.fuchsia
    },
    paymentRuns: {
        name: 'paymentRuns',
        icon: 'mdi:invoice-line-items-outline',
        color: appColors.fuchsia,
        search: {
            listing: 'service-payments-paymentRuns',
            detail: 'service-payments-paymentRuns-id-paymentRunBaseData',
            nameProp: 'funding_program_name',
            infoProp: 'created_at'
        },
    },
    fundingPrograms: {
        name: 'fundingPrograms',
        icon: 'heroicons:banknotes',
        color: 'primary',
        search: {
            listing: 'service-basicData-fundingPrograms',
            detail: 'service-basicData-fundingPrograms-id-fundingProgramBaseData',
            nameProp: 'name'
        },
    },
    forms: {
        name: 'forms',
        icon: 'heroicons:document-text',
        color: 'primary',
        search: {
            listing: 'service-basicData-forms',
            detail: 'service-basicData-forms-id-formBaseData',
            nameProp: 'name'
        },
    },
    settings: {
        name: 'settings',
        icon: 'heroicons:cog-6-tooth',
        color: appColors.slate,
    },
    basicData: {
        name: 'basicData',
        icon: 'heroicons:wrench-screwdriver',
        color: 'primary'
    },
    roles: {
        name: 'roles',
        icon: 'heroicons:credit-card',
        color: 'primary',
        search: {
            listing: 'service-basicData-roles',
            detail: 'service-basicData-roles-name-roleBaseData',
            idProp: 'name',
            nameProp: 'name_de'
        },
    },
    mailTemplates: {
        name: 'mailTemplates',
        icon: 'heroicons:envelope',
        color: appColors.yellow,
        search: {
            listing: 'service-basicData-mailTemplates',
            detail: 'service-basicData-mailTemplates-id-mailTemplateBaseData',
        },
    },
    mails: {
        name: 'mails',
        icon: 'heroicons:envelope',
        color: appColors.yellow,
        search: {
            listing: 'service-basicData-mails',
            detail: 'service-basicData-mails-id-mailBaseData',
        },
    },
    logout: {
        name: 'logout',
        icon: 'heroicons:arrow-right-on-rectangle',
        color: 'primary'
    },
}
